export const useGetUrlParams = () => {
    const paramsObj = new URLSearchParams(window.location.search);

    const seasonId = paramsObj.get('seasonId');
    const roundId = paramsObj.get('roundId');
    const category = paramsObj.get('category');
    const sortDirection = paramsObj.get('sortDirection');
    const sortColumn = paramsObj.get('sortColumn');
    const dataType = paramsObj.get('dataType');
    const benchmarking = paramsObj.get('benchmarking');
    const positions = paramsObj.get('positions');
    const teams = paramsObj.get('teams');

    return {
        seasonId,
        roundId,
        category,
        sortDirection,
        sortColumn,
        dataType,
        benchmarking,
        positions: positions ? positions.split(',') : [],
        teams: teams ? teams.split(',') : []
    };
};
